import { countries, Country } from 'typed-countries';

const preferred: string[] = [
  'United States',
  'United Kingdom',
  'Indonesia',
  'Saudi Arabia',
  'Canada',
  'Taiwan',
  'Thailand',
  'Poland',
  'Brazil',
  'Mexico',
];

export type Option = {
  label: string;
  value: string;
};

export const countryList = () => {
  const all = countries.map((country) => ({
    label: country.name,
    value: country.name,
  }));

  return preferred
    .map((country: string) => ({ label: country, value: country }))
    .concat([{ label: '---------------', value: '' }])
    .concat(all);
};

export default countryList;
